import { Component, OnInit, Renderer, TemplateRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { PageCalculator } from 'src/app/model/PagingInfo';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { AlertService } from 'src/app/services/alert.service';
import { ToastrService } from 'ngx-toastr';
// declare var $: any
@Component({
  selector: 'app-assign-user',
  templateUrl: './assign-user.component.html',
  styleUrls: ['./assign-user.component.css']
})
export class AssignUserComponent implements OnInit {
  modalRef: BsModalRef;
  userList: any = [];
  is_add: boolean = false;
  static is_edit: boolean = false;
  static is_delete: boolean = false;
  app_id: any;
  application: any = [];
  application_name: any;
  app_code: any;
  model: any = {}
  application_code: any;
  gotoLastPage: boolean;
  gotoFirstPage: boolean;
  numberOfPages: number;
  pagerItems: any = [];
  data: any = [];
  recordsFiltered: number;
  recordsTotal: any;
  allFeatures: boolean = true;
  disablePrev: string = 'disabled active';
  disableNextLast: string;
  currentPage: number = 1;
  start: number = 0;
  length: number = 10
  lengthMenu: any = [10, 25, 50, 100]
  dropdownList = [];
  roleDropdownList = [];
  dropdownSettings = {};
  roledropdownSettings = {};
  roleList: any = [];
  selectedUsers: any = [];
  showModal: boolean = false;
  SelectedItems: any = [];
  selectedRoles: any = []
  is_data: boolean = false
  selectedUserId: any;
  is_userdropdownFilled: boolean = false;
  is_roledropdownFilled: boolean = false;
  org_id: string;
  username: string;
  constructor(private renderer: Renderer,
    private router: Router,
    private authService: AuthService,
    private accessControlService: AccessControlService,
    private checkPermissionService: CheckPermissionService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private modalService: BsModalService,private toastrService:ToastrService) {
    this.app_id = this.activatedRoute.snapshot.params['id'];
    this.app_code = this.activatedRoute.snapshot.queryParamMap.get('opt')

  }
  openModal(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(template, config);
  }
  ngOnInit() {
    this.org_id = localStorage.getItem('user_id');
    this.username = localStorage.getItem('user_name');
    this.dropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      imitSelection: 5,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search by username',
      noDataAvailablePlaceholderText: 'No data available',
    };
    localStorage.setItem('option', 'global_access_control');
    this.activatedRoute.queryParamMap.subscribe((query: any) => {
      this.application_name = query.params.appname;
    });
    this.getapplicationbyId();
  }
  
  onUserSelect() {
    this.is_userdropdownFilled = false;
  }
  onSelectAllUsers() {
    this.is_userdropdownFilled = false;
  }

  getapplicationbyId() {
    this.accessControlService.getapplicationbyId(this.app_id).subscribe((res) => {
      this.application = res;
      this.model = this.application
      this.application_name = this.application.application_name;
      this.application_code = this.application.application_code;

      // if (this.username + "" == "admin@gsf.com") {
      //   this.listallUsers();
      // }
      // else {
        this.listallUsersWithinOrg();
      // }

    }, error => {
      console.log(error)
    },
      () => {

      })
  }
  listallUsers() {
    this.authService.listallUsers().subscribe((res) => {
      this.userList = res
      this.dropdownList = this.userList
      for (var i = 0; i < this.dropdownList.length; i++) {
        for (var j = 0; j < this.model.userlist.length; j++) {
          if (this.dropdownList[i]._id == this.model.userlist[j]._id) {
            this.dropdownList.splice(i, 1);
          }
        }
      }
    }, error => {

    }, () => {
    })
  }
  listallUsersWithinOrg() {
    this.authService.listallUsersWithinOrg(this.org_id).subscribe((res) => {
      this.userList = res
      this.dropdownList = this.userList
      for (var i = 0; i < this.dropdownList.length; i++) {
        for (var j = 0; j < this.model.userlist.length; j++) {
          if (this.dropdownList[i]._id == this.model.userlist[j]._id) {
            this.dropdownList.splice(i, 1);
          }
        }
      }
    }, error => {

    }, () => {
    })
  }
  // goToPage(page) {
  //   this.currentPage = page;
  //   this.disablePrev = this.currentPage == 1 ? 'disabled active' : ' ';
  //   if (this.pagerItems.length == this.currentPage) {
  //     this.disableNextLast = 'disabled active';
  //   }
  //   this.start = (this.currentPage - 1) * this.length;
  //   // this.getTableItems(false);
  //   this.listallUsers();
  // }



  updateApplication(executableCondition: any) {
    var date = new Date();
    this.model.updated_on = date
    this.accessControlService.updateApplication(this.model).subscribe((res) => {
      this.getapplicationbyId();
    }, error => {
      console.log(error)
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastrService.error(errorMessage)
    }, () => {
    })
  }
  assignUser() {
    debugger
    if (this.SelectedItems.length == 0) {
      this.is_userdropdownFilled = true
      return
    }
    else {
      this.is_userdropdownFilled = false
      this.model.app_id = this.app_id
      this.model.userlist = this.SelectedItems
      this.model.clientId=localStorage.getItem("org_id");
      this.accessControlService.assignUser(this.model).subscribe((res) => {
        this.SelectedItems = [];
      }, error => {
        console.log(error)
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.alertService.errorAlert(errorMessage)
      }, () => {
        this.toastrService.success("User successfully assigned.");
        // this.getapplicationbyId();
        this.router.navigate(["/app-user-listing/" + this.app_id],{queryParams:{appname:this.application_name}});

      })
    }
  }
}

